define('page/appdown', ['jquery', 'jquery.qrcode'], $ => {
    function getChannel() {
        return window.location.href.match(/\/\d+/);
    }

    function init() {
        if (RRC.dynamicAppEntry) {
            return;
        }

        // make qrcode
        const channel = getChannel();
        let car_url = `${location.protocol}//app.renrenche.com/channel/681`;
        if (channel) {
            car_url = `${location.protocol}//app.renrenche.com/channel${channel}`;
            $('#js-android').attr('href', car_url);
        }

        $('#js-appdown-qr').empty().qrcode({
            render: 'image',
            text: car_url,
            size: 188,
        });
    }

    return {
        getChannel,
        init,
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/appdown'], page => {
        page.init();
    });
}
